// src/hooks/useAccountBilling.js
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { format } from 'date-fns';

const ACCOUNT_OVERVIEW_KEY = ['accountOverview'];

export const useAccountBilling = () => {
    const {
        data: overview,
        isLoading,
        error,
        refetch,
    } = useQuery({
        queryKey: ACCOUNT_OVERVIEW_KEY,
        queryFn: () => api.get('/company/account-overview').then(res => res.data.data),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });

    const currentSubscription = overview?.current_subscription || null;

    const paymentHistory = overview?.history || [];

    const isTrial = !currentSubscription || !currentSubscription.is_active;

    const activeSince = currentSubscription
        ? format(new Date(currentSubscription.start_date), 'MMM d, yyyy')
        : 'Nov 16, 2025';

    const trialEndDate = currentSubscription?.end_date
        ? format(new Date(currentSubscription.end_date), 'MMM d, yyyy')
        : null;

    const planName = currentSubscription?.plan?.title || 'Free Trial';
    const planPrice = currentSubscription?.price
        ? `$${parseFloat(currentSubscription.price).toFixed(2)}`
        : 'Free';

    return {
        overview,
        currentSubscription,
        paymentHistory,
        isTrial,
        activeSince,
        trialEndDate,
        planName,
        planPrice,
        isLoading,
        error,
        refetch,
    };
};